/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import Ripples from "react-ripples";
import { useAxiosKaraokeConfigGlobal } from "../../Config/axios";
import { distributionUrl, karaokeUrl } from "../../Config/url";
import { IconController, ImgController } from "../../Scripts/ImgController";
import CreationCard from "../../UI/Creation/CreationCard";
import assets from "../../../assets/assets";
import Pagination from "../../UI/pagination";
const Wrapper = styled.div`
  .table-border {
    border: 1px solid #e5e7eb;
  }

  .color-CK {
    color: #333843;
  }
  table {
    width: 100%;
  }
  .table-header {
    background: #f3f4f6;
  }
  .list td {
    width: 21.6%;
    padding: 24px;
  }
  .list td:first-child {
    width: 35.2%;
  }
  .skeleton td {
    width: 21.6%;
    padding: 12px 24px;
  }
  .skeleton td:first-child {
    width: 35.2%;
  }
  .text-color-grey {
    color: #6b7280;
  }
  tr {
    border-bottom: 1px solid #e5e7eb;
  }
  tr:last-child {
    border-bottom: none;
  }
  .table-footer {
    border-top: 1px solid #d1d5db;
    width: 100%;
    padding: 16px 24px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .active {
    color: #ffffff;
    background-color: #0061ff;
  }
  @media (max-width: 767px) {
    .list td {
      padding: 12px;
    }
    .skeleton td {
      padding: 12px;
    }
    th .px-6 {
      padding: 12px;
    }
    .table-footer {
      flex-direction: column;
      gap: 12px;
      padding: 12px;
    }
  }
`;

const KaraokeCreation = ({ oneRingRulesAll }) => {
  const [generalData, setGeneralData] = useState([]);
  const [sangCount, setSangCount] = useState(Number);
  const [songsList, setSongsList] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [listLinks, setListLinks] = useState(Object);
  const [listMeta, setListMeta] = useState(Object);
  const [listSort, setListSort] = useState("");
  const [paginationLinks, setPaginationLinks] = useState([]);
  const [requestParams, setRequestParams] = useState(
    `panel-api/oauth/content:sang?sort=${listSort}&page[number]=${pageNumber}&page[size]=10`
  );
  const axiosConfig = useAxiosKaraokeConfigGlobal();

  const [generalCardLoaded, setGeneralCardLoaded] = useState(false);
  const [card3Loaded, setCard3Loaded] = useState(false);
  const [listLoaded, setListLoaded] = useState(false);

  const [titleTime, setTitleTime] = useState(false);

  useEffect(() => {
    document.title = "MMusic - Уран бүтээл";
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("creation-karaoke-generalData")) {
      const res = JSON.parse(
        sessionStorage.getItem("creation-karaoke-generalData")
      );

      setGeneralData(res.data.data);
      setGeneralCardLoaded(true);
    } else {
      axios
        .get(
          distributionUrl + "panel-api/oauth/karaoke/content:count",
          axiosConfig
        )
        .then((res) => {
          setGeneralData(res.data.data);
          setGeneralCardLoaded(true);
          sessionStorage.setItem(
            "creation-karaoke-generalData",
            JSON.stringify(res)
          );
        })
        .catch((err) => {
          if (err.response.status === 401) {
            oneRingRulesAll("logout");
          }
        });
    }

    if (sessionStorage.getItem("creation-karaoke-sangCount")) {
      const res = JSON.parse(
        sessionStorage.getItem("creation-karaoke-sangCount")
      );
      setSangCount(res.data.data);
      setCard3Loaded(true);
    } else {
      axios
        .get(karaokeUrl + "panel-api/oauth/sang:count", axiosConfig)
        .then((res) => {
          setSangCount(res.data.data);
          setCard3Loaded(true);
          sessionStorage.setItem(
            "creation-karaoke-sangCount",
            JSON.stringify(res)
          );
        })
        .catch((err) => {
          if (err.response.status === 401) {
            oneRingRulesAll("logout");
          }
        });
    }
  }, []);

  useEffect(() => {
    const fetchSangs = async () => {
      try {
        const res = await axios.get(karaokeUrl + requestParams, axiosConfig);

        let originalList = res.data.data;

        if (!Array.isArray(originalList)) {
          originalList = Object.values(originalList);
          console.error(
            "originalList is not an array, converting to array:",
            originalList
          );
        }

        const ids = originalList.map((song) => song.song_id).join(",");

        const response = await axios.get(
          `${distributionUrl}panel-api/oauth/songs/ids?ids=${ids}`,
          axiosConfig
        );

        const songMap = {};
        response.data.data.forEach((song) => {
          songMap[song.id] = song;
        });

        const enrichedList = originalList.map((item) => ({
          ...item,
          song: songMap[Number(item.song_id)] || null,
        }));

        // ✅ Set state here
        setSongsList(enrichedList);
        setListMeta(res.data.meta);
        setListLinks(res.data.links);
        setPageNumber(res.data.meta.current_page);
        setListLoaded(true);
        generatePagination(
          res.data.meta.current_page,
          res.data.meta.last_page,
          res.data.meta.links[1].url
        );
      } catch (err) {
        if (err.response?.status === 401) {
          oneRingRulesAll("logout");
        } else {
          console.error("Error fetching songs:", err);
        }
      }
    };

    fetchSangs();
  }, [requestParams]);

  function generatePagination(currentPage, totalPages, urlExample) {
    const reqUrl = urlExample.slice(0, -1);
    const pagination = [];

    // "Previous" arrow
    if (currentPage > 1) {
      pagination.push({
        label: "&laquo; Previous",
        active: false,
        url: reqUrl + (currentPage - 1),
      });
    }

    // Page numbers
    pagination.push({
      label: 1,
      active: 1 === currentPage,
      url: 1 === currentPage ? null : reqUrl,
    });

    if (currentPage > 3) {
      pagination.push({
        label: "...",
        active: false,
        url: null,
      });
    }

    for (
      let i = Math.max(2, currentPage - 1);
      i <= Math.min(totalPages - 1, currentPage + 1);
      i++
    ) {
      pagination.push({
        label: i,
        active: i === currentPage,
        url: i === currentPage ? null : reqUrl + i,
      });
    }

    if (currentPage < totalPages - 2) {
      pagination.push({
        label: "...",
        active: false,
        url: null,
      });
    }

    pagination.push({
      label: totalPages,
      active: totalPages === currentPage,
      url: totalPages === currentPage ? null : reqUrl + totalPages,
    });

    // "Next" arrow
    if (currentPage < totalPages) {
      pagination.push({
        label: "Next &raquo;",
        active: false,
        url: reqUrl + (currentPage + 1),
      });
    }
    setPaginationLinks(pagination);
  }
  const mappedList = songsList.map((data) => {
    return (
      <tr key={data?.song_id} className="list">
        <td>
          <div className="flex flex-row items-center gap-2">
            <ImgController
              src={data?.song?.cover}
              className="w-11 h-11"
              imgClassName="rounded-lg"
            />
            <div className="flex flex-col text-start ">
              <h5 className="text-xs font-medium text-color-grey">
                {data?.artist_name}
              </h5>
              <h5 className="text-sm font-medium">{data?.song_title}</h5>
              <h5 className="text-xs font-medium text-color-grey">
                {data?.song?.album?.release_type === "standard"
                  ? "Album"
                  : "Single"}
              </h5>
            </div>
          </div>
        </td>
        <td>
          <span className="text-sm text-color-grey">{data?.total}</span>
        </td>
      </tr>
    );
  });
  const mappedPagination = paginationLinks?.map((link) => {
    const trimmedLink = link?.url?.split(
      karaokeUrl.replace("http://", "").replace("https://", "")
    )[1];
    if (link.label === "&laquo; Previous") {
      return (
        <Ripples
          color="#ffffff40"
          during={600}
          className="rounded-lg"
          key={link.label}
        >
          <div
            className="pagination-bg hasHover"
            onClick={() => {
              if (link.url !== null) {
                setRequestParams(trimmedLink);
                setListLoaded(false);
              }
            }}
          >
            ⬅
          </div>
        </Ripples>
      );
    }
    if (link.label === "Next &raquo;") {
      return (
        <Ripples
          color="#ffffff40"
          during={600}
          className="rounded-lg"
          key={link.label}
        >
          <div
            className="pagination-bg hasHover"
            onClick={() => {
              if (link.url !== null) {
                setRequestParams(trimmedLink);
                setListLoaded(false);
              }
            }}
          >
            ⮕
          </div>
        </Ripples>
      );
    } else {
      return (
        <Ripples
          color="#ffffff40"
          during={600}
          className="rounded-lg"
          key={link.label === "..." ? Math.random() : link.label}
        >
          <div
            className={`pagination-bg ${link?.active ? "active" : "hasHover"}`}
            onClick={() => {
              if (link.url !== null) {
                setRequestParams(trimmedLink);
                setListLoaded(false);
              }
            }}
          >
            <span className="font-inter text-sm font-bold">{link?.label}</span>
          </div>
        </Ripples>
      );
    }
  });
  const ListSkeleton = () => {
    const arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    return arr.map((a) => {
      return (
        <tr key={a} className="skeleton">
          <td>
            <div className="flex flex-row items-center gap-3">
              <Skeleton height="44px" width="44px" />
              <div className="flex flex-col w-full" height="32px">
                <Skeleton height="8px" width="50%" />
                <Skeleton height="8px" width="75%" />
                <Skeleton height="8px" width="25%" />
              </div>
            </div>
          </td>
          <td>
            <Skeleton width="50%" />
          </td>
        </tr>
      );
    });
  };

  const sortHandler = (value) => {
    setTitleTime(!titleTime);
    setListSort((titleTime ? "" : "-") + value);
    setRequestParams(
      `panel-api/oauth/content:sang?sort=${
        (titleTime ? "" : "-") + value
      }&page[number]=${pageNumber}&page[size]=10`
    );
  };

  return (
    <Wrapper className="py-4 px-1 md:py-8 md:px-5">
      <h5 className="text-mmusic text-xl font-semibold pb-3 pl-3">
        Уран бүтээлүүд
      </h5>
      <div className="w-full flex flex-row flex-wrap">
        <CreationCard
          className="w-1/2"
          gradientColor="0061FF"
          number={generalData?.songs?.count}
          numberColor="1E3A8A"
          desc="Нийт уран бүтээл"
          descColor="3B82F6"
          icon={assets.svg.CardIcon1}
          loaded={generalCardLoaded}
        />
        <CreationCard
          className="w-1/2"
          gradientColor="EC4899"
          number={sangCount}
          numberColor="9D174D"
          desc="Нийт дуулалт"
          descColor="EC4899"
          icon={assets.svg.CardIcon3}
          loaded={card3Loaded}
        />
      </div>
      <div className="px-3 pt-2">
        <div className="table-border rounded-lg">
          <div className="px-4 md:px-6 py-4 md:py-5 flex flex-row justify-between items-center">
            <h4 className="font-medium text-base md:text-lg">Нийт уран бүтээлийн хүснэгт</h4>
          </div>
          <div className="overflow-x-auto">
          <table className="min-w-[360px]">
            <thead>
              <tr className="table-header">
                <th>
                  <Ripples color="#0061FF40" during={600} className="w-full">
                    <div
                      className="px-6 py-4 w-full flex flex-row justify-between cursor-pointer"
                      onClick={() => {
                        sortHandler("song_title");
                      }}
                    >
                      <h5 className="text-sm font-medium">Уран бүтээл</h5>
                      <IconController
                        src={assets.svg.ChevronDown}
                        className={`w-5 h-5 ${
                          listSort === "song_title" ? "rotate-180" : ""
                        } `}
                      />
                    </div>
                  </Ripples>
                </th>
                <th>
                  <Ripples color="#0061FF40" during={600} className="w-full">
                    <div
                      className="px-6 py-4 w-full flex flex-row justify-between cursor-pointer"
                      onClick={() => {
                        sortHandler("total");
                      }}
                    >
                      <h5 className="text-sm font-medium">Дуулалт</h5>

                      <IconController
                        src={assets.svg.ChevronDown}
                        className={`w-5 h-5 ${
                          listSort === "total" ? "rotate-180" : ""
                        } `}
                      />
                    </div>
                  </Ripples>
                </th>
              </tr>
            </thead>
            <tbody>{listLoaded ? mappedList : ListSkeleton()}</tbody>
          </table>
          </div>
          <div className="table-footer">
            <h5 className="text-sm font-medium text-center md:text-left">
              нийт {listMeta?.total} дуунаас {listMeta?.from}-{listMeta?.to}{" "}
              харуулж байна
            </h5>
            <div className="flex flex-row flex-wrap justify-center gap-1 md:gap-2">{mappedPagination}</div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default KaraokeCreation;
